import React from "react";
import TabContent from "./TabContent";

const OthersTab = ({
  data,
  reload,
  currentPage,
  itemsPerPage,
  selectedTab,
  onViewFile,
  onDeleteFile,
}) => {
  return (
    <TabContent
      data={data}
      reload={reload}
      currentPage={currentPage}
      itemsPerPage={itemsPerPage}
      selectedTab={selectedTab}
      onViewFile={onViewFile}
      onDeleteFile={onDeleteFile}
    />
  );
};

export default OthersTab;
